export const IS_BOX_EXPANDED = "IS_BOX_EXPANDED";
export const IS_MISSING_FILOGIX_DETAILS_DISMISSED = "IS_MISSING_FILOGIX_DETAILS_DISMISSED";
const getters = {
  [IS_BOX_EXPANDED]: state => ({
    username,
    collapseComponentName
  }) => {
    var _state$collapseBoxes$, _state$collapseBoxes$2;
    return (_state$collapseBoxes$ = (_state$collapseBoxes$2 = state.collapseBoxes.byId[username]) == null ? void 0 : _state$collapseBoxes$2[collapseComponentName]) != null ? _state$collapseBoxes$ : true;
  },
  [IS_MISSING_FILOGIX_DETAILS_DISMISSED]: state => ({
    username,
    applicationId
  }) => {
    var _state$dismissMissing, _state$dismissMissing2;
    return (_state$dismissMissing = (_state$dismissMissing2 = state.dismissMissingFilogixDetailsBanner[applicationId]) == null ? void 0 : _state$dismissMissing2[username]) != null ? _state$dismissMissing : false;
  }
};
export default getters;